// @flow
import { ClientError, ServerError } from 'lib/errors';

export default function checkIfResponseIsOK(response: Response): * {
  if (!response.ok) {
    const { status, statusText } = response;

    return Promise.reject(
      status < 500
        ? new ClientError(statusText, status)
        : new ServerError(statusText, status)
    );
  }

  return response;
}



// WEBPACK FOOTER //
// ./src/api/checkIfResponseIsOK.js